import axiosClient from "@/libs/axiosClient";

export const ipValidate = (topic, val) => {
    return axiosClient.post(`/validate/ipvalidate`, {
        topic: topic,
        val: val
    });
};

export const luceneValidate = val => {
    return axiosClient.post(`/validate/lucenevalidate`, {
        val: val
    });
};

export const scrollValidate = val => {
    return axiosClient.post(`/validate/scrollvalidate`, {
        val: val
    });
};



// WEBPACK FOOTER //
// ./src/api/formValidate.js